import React from 'react';
import { useSelector } from 'react-redux';
import { Navigate, Route, Routes } from 'react-router-dom';
import Home from './pages/Home';
import Login from './pages/Login';
import Registration from './pages/Registration';
function App() {
  const auth = useSelector((state) => state.auth);
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/register" element={<Registration />} />
      <Route path="/home" element={<Home />} />
      <Route path="/" element={<Home />} />
      <Route
        path="*"
        element={<Navigate to={auth.isLoggedIn ? '/home' : '/login'} />}
      />
    </Routes>
  );
}

export default App;
